import { DocumentDetails } from './CommonTypes';

export interface CorrespondenceDetails {
  correspondence: string;
  correspondenceId: string;
  createdByUserId: string;
  createdByUserEmail: string;
  createdOn: number;
  documentList: Array<DocumentDetails>;
  lastUpdatedByUser: string;
  lastUpdatedOn: number;
  correspondenceType: CorrespondenceType;
}

//ListCorrespondence - Response
export interface ListCorrespondenceTypeResponse {
  correspondenceDetailsList: Array<CorrespondenceDetails>;
}

//ListCorrespondence - Request
export interface ListCorrespondenceTypeRequest {
  userId: string;
  accountId: string;
  authorizationToken?: string;
  caseId: string;
}

export enum CorrespondenceType {
  POST_INTERNAL_ONLY = 'POST_INTERNAL_ONLY',
  POST = 'POST',
  ACKNOWLEDGEMENT_TO_INTERNAL = 'ACKNOWLEDGEMENT_TO_INTERNAL',
  ACKNOWLEDGEMENT_TO_EXTERNAL = 'ACKNOWLEDGEMENT_TO_EXTERNAL',
}
//AddCorrespondence - Request
export interface AddCorrespondenceTypeRequest {
  userId: string;
  userEmail: string;
  accountId: string;
  authorizationToken?: string;
  caseId: string;
  correspondence?: string;
  clientId: string;
  documentList: Array<DocumentDetails>;
  correspondenceType: CorrespondenceType;
}

//AddCorrespondence - Response
export interface AddCorrespondenceTypeResponse {
  correspondenceId: string;
}
